import React from "react";
import { BackendFailureAlert } from "@platform/core";
import { Box, Grid2 as Grid, pxToRem, Typography } from "@platform/style";
import { WorkItemHistoryList } from "./WorkItemHistoryList";
import { ActivityRecordPage } from "../../models/ActivityRecordPage";
import { ActivityRecord, ActivityType } from "../../models/ActivityRecord";

interface RenderHistoryProps {
  isErrored: boolean;
  refetch: any;
  data: ActivityRecordPage | null;
  correlationId: string;
  errorStack: string;
}

const NO_WORKITEM_HISTORY_MSG = "There is no work item history.";
let validActivityRecords: ActivityRecord[];

function getValidActivityRecords(rec: ActivityRecord[]) {
  validActivityRecords = rec.filter((rtc) => {
    return (
      !!rtc.Activity && !!rtc.PerformedBy && !!rtc.ActivityDatetime && rtc.Activity in ActivityType
    );
  });

  return validActivityRecords.length;
}

export const RenderHistory = ({
  isErrored,
  refetch,
  data,
  correlationId,
  errorStack,
}: RenderHistoryProps) => {
  return isErrored ? (
    <Grid container paddingTop={pxToRem(15)} paddingLeft={pxToRem(2)} paddingRight={pxToRem(24)}>
      <Box width={"100%"}>
        <BackendFailureAlert
          retryFunction={refetch}
          component={"ShowWorkItemHistory"}
          correlationId={correlationId}
          exceptionInformation={errorStack}
        />
      </Box>
    </Grid>
  ) : data &&
    data.ActivityRecords &&
    data.ActivityRecords.length > 0 &&
    getValidActivityRecords(data.ActivityRecords) > 0 ? (
    WorkItemHistoryList({ activityRecords: validActivityRecords, listIndex: 1 })
  ) : (
    <Typography variant={"body3"}>{NO_WORKITEM_HISTORY_MSG}</Typography>
  );
};
